import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagramSquare,
  faTwitterSquare,
  faYoutubeSquare,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const logo = `${process.env.PUBLIC_URL}/WhiteLOGOO.png`;

const SOCIALS = [
  { icon: faFacebookSquare, href: "https://www.facebook.com/TheeCityChurch", label: "Facebook" },
  { icon: faInstagramSquare, href: "https://www.instagram.com/theecitychurch/", label: "Instagram" },
  { icon: faLinkedin, href: "https://www.linkedin.com/company/the-city-church-luzira/", label: "LinkedIn" },
  { icon: faTwitterSquare, href: "https://x.com/TheCityChurchL/", label: "Twitter / X" },
  { icon: faYoutubeSquare, href: "https://www.youtube.com/@thecitychurch-luzira2585/", label: "YouTube" },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="tcc-container footer__inner">
        {/* Brand / contact */}
        <div className="footer__brand">
          <img src={logo} alt="The City Church" className="footer__logo" />
          <p className="footer__tagline">
            A community of faith, hope and love across Luzira, Kirinya and Iganga.
          </p>
          <ul className="footer__contact">
            <li><FaMapMarkerAlt aria-hidden="true" /> Luzira, Kampala, Uganda</li>
            <li><FaPhoneAlt aria-hidden="true" /> <a href="tel:+256704083043">+256 704 083043</a></li>
            <li><FaEnvelope aria-hidden="true" /> <a href="mailto:info@thecitychurchluzira.org">info@thecitychurchluzira.org</a></li>
          </ul>
          <div className="footer__socials">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} aria-label={s.label} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={s.icon} size="2x" />
              </a>
            ))}
          </div>
        </div>

        {/* Link columns */}
        <nav className="footer__cols" aria-label="Footer">
          <div className="footer__col">
            <h2 className="footer__heading">Reach Out</h2>
            <a href="https://thecitychurchluzira.churchcenter.com/people/forms/938178">Support a Mission</a>
            <a href="https://thecitychurchluzira.churchcenter.com/people/forms/938160">Partner With Us</a>
            <a href="https://thecitychurchluzira.churchcenter.com/people/forms/938154">Need Prayer</a>
          </div>
          <div className="footer__col">
            <h2 className="footer__heading">Missions</h2>
            <Link to="/fitforlife">Fit for Life</Link>
            <Link to="/Cli">City Leadership Institute</Link>
            <a href="https://www.transformafricanministries.org/" target="_blank" rel="noopener noreferrer">Transform African Ministries</a>
          </div>
          <div className="footer__col">
            <h2 className="footer__heading">Resources</h2>
            <a href="https://thecitychurchluzira.churchcenter.com/people/forms/937756">First Time Guests</a>
            <Link to="/bookLib">Books</Link>
            <a href="https://open.spotify.com/artist/48Uz3wlAuTWxnvj4uXQPD2" target="_blank" rel="noopener noreferrer">Music</a>
          </div>
          <div className="footer__col">
            <h2 className="footer__heading">Get Involved</h2>
            <Link to="/give">Give</Link>
            <Link to="/join-mc">Plan a Visit</Link>
            <Link to="/contact-us">Contact Us</Link>
          </div>
        </nav>
      </div>

      <div className="footer__bar">
        <div className="tcc-container footer__bar-inner">
          <span>© {new Date().getFullYear()} The City Church. All rights reserved.</span>
          <a href="/term-of-service" target="_blank" rel="noopener noreferrer">Privacy &amp; Terms</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
